export default {"src":"/_next/static/media/icon-impact.96248cc0.svg","height":33,"width":33,"blurWidth":0,"blurHeight":0};